import React, { useEffect, useState } from 'react'
import InputText from '../InputText'
import Text from '../../atoms/Text'
import InputCheckbox from '../InputCheckbox'
import { FormInstance } from 'antd'

export type InputCheckerProps = {
  inputDescription: string
  checkBoxLabel: string
  type: string
  label: string
  form?: FormInstance<any>
  disabled?: boolean
  required?: boolean
  errorMessage?: string
  tooltip?: string
}

const InputChecker = ({
  inputDescription,
  checkBoxLabel,
  type,
  label,
  form,
  disabled,
  required,
  errorMessage,
  tooltip,
}: InputCheckerProps) => {
  const styles = {
    wrapper: { display: 'flex', alignItems: 'center' },
    desc: { marginTop: 15, marginLeft: 5 },
    input: { maxWidth: 150 },
  }

  const checkBoxValue = form?.getFieldValue(type)

  const [checked, setChecked] = useState(false)

  useEffect(() => {
    const isFormTouched = form?.isFieldsTouched()
    setChecked(isFormTouched ? !checkBoxValue && checkBoxValue !== 0 : false)
  }, [checkBoxValue, form])

  useEffect(() => {
    if (checked) {
      form?.setFields([{ name: type, value: null }])
    }
    if (disabled) {
      setChecked(false)
    }
  }, [checked, disabled])

  return (
    <div>
      <div style={styles.wrapper}>
        <InputText
          type={type}
          label={label}
          layout="column"
          placeholder=""
          style={styles.input}
          disabled={checked || disabled}
          formItemMaxWidth={150}
          asNumberInput
          required={required && !checked}
          errorMessage={errorMessage}
          tooltip={tooltip}
        />
        {inputDescription && (
          <Text style={styles.desc} as="p2">
            {inputDescription}
          </Text>
        )}
      </div>
      <InputCheckbox
        onChange={(e) => setChecked(e.target.checked)}
        value={checked}
        withoutInput
        disabled={disabled}
      >
        {checkBoxLabel}
      </InputCheckbox>
    </div>
  )
}

export default InputChecker
